export const navigationMenu = {
	'/offer-list': ['/offer/'],
	'/quote-list': ['/quote/'],
}
